export default __webpack_public_path__ + "static/seo-analysis-b8f3abe9d2c29ecbc715a19c4ff5d1f1.png";